'use client'

import * as React from 'react'
import { Link as LinkComponent } from '@repo/web-ui/components/link'
import { tw } from 'utils/classnames'

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  icon?: React.ReactNode
  prefetch?: boolean
  component?: 'Link' | 'a'
  className?: string
  children?: React.ReactNode
}

export const Link: React.FC<LinkProps> = ({
  icon,
  className,
  prefetch = false,
  component = 'a',
  href,
  children,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href?.startsWith('#')) {
      e.preventDefault()
      const targetElement = document.querySelector(href)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <LinkComponent
      href={href}
      onClick={handleClick}
      className={tw('text-12 text-[#2A1F3F] underline', className)}
      component={component}
      prefetch={prefetch}
      {...rest}
    >
      {icon ? <span className="mr-2">{icon}</span> : null}
      {children}
    </LinkComponent>
  )
}
